import styled from 'styled-components';

const DetailUpperBoxContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DetailUpperBoxContainerTitleStyled = styled.div`
  max-width: 140px;

  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #0e141d;
`;

const DetailUpperBoxContainerContentStyled = styled.div`
  text-align: right;
  font-size: 16px;
  line-height: 20px;
  color: #0e141d;
`;

export {
  DetailUpperBoxContainerStyled,
  DetailUpperBoxContainerTitleStyled,
  DetailUpperBoxContainerContentStyled,
};
